import React from 'react'

import { useFormattedCurrentDateParts } from '@/components/Event/NewScript/hooks/useFormattedCurrentDateParts'
import { formatTimeInTimezoneWithAbbreviation } from '@/utils/time'

type CNAVerbatimProps = {
  timezone: string
  eventName: string
  eventDatetime: string
  witnessName: string
}

export const CNAVerbatim: React.FC<CNAVerbatimProps> = ({
  timezone,
  eventName,
  eventDatetime,
  witnessName,
}) => {
  const dateTime = useFormattedCurrentDateParts(timezone)
  const eventScheduledStartTime = formatTimeInTimezoneWithAbbreviation(
    eventDatetime,
    timezone,
  )

  return (
    <>
      Today is {dateTime.dayOfWeek}. It is {dateTime.formattedDate}, the time is{' '}
      {dateTime.formattedTimeWithTimezone}. We are present to record the{' '}
      {eventName} which was scheduled for {eventScheduledStartTime}.{' '}
      {witnessName} has failed to appear and accordingly at this time I will be
      issuing a certificate of non-appearance.
    </>
  )
}
